/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from "@theme-ui/mdx"
import { useState } from "react"
import FocusLock from "react-focus-lock"
import axios from "axios"
import { connect } from "react-redux"
import { Formik } from "formik"
import * as Yup from "yup"
import get from "lodash/get"
import Button from "@components/Button"
import { rem } from "@src/theme"
import TextInput from "@components/form/TextInput"
import FieldSpacer from "@components/form/FieldSpacer"
import SelectInput from "@components/form/SelectInput"
import TextArea from "@components/form/TextArea"
import { Grid } from "@theme-ui/components"
import useGTM from "@src/utils/useGTM"
import Checkbox from "@components/form/Checkbox"

import HubspotForm from "@components/HubspotForm"
import HubspotEmbed from "@components/HubspotEmbed"

const defaultDisclaimer = "By signing up, you agree to receive updates about this Minus18 campaign and our work supporting LGBTQIA+ young people. You can unsubscribe anytime."
const wipDisclaimer = "By pledging, you agree to receive updates about Minus18’s Wear It Purple® Day campaign and our work supporting LGBTQIA+ young people. You can unsubscribe anytime."
const HubspotModal = ({ closeHubspotModal, hubspotTag }) => {

  const hubspotEmbedMap = {
    // wear it purple campaign
    'wear it purple day':
    {
      region: "na1",
      portalId: "21250167",
      formId: "774f931f-fd6b-4b07-b33e-8e21143e36c8"
    }
    ,
    // trans awareness week
    'trans awareness week': {
      region: "na1",
      formId: "1c665bdd-fb63-4bfe-b6c1-059f9d68441d",
      portalId: "21250167"
    }
  }

  const hubspotEmbed = hubspotEmbedMap[hubspotTag.toLowerCase()] || null



  return (
    <div>
      <FocusLock>

        {hubspotEmbed &&
          <HubspotEmbed
            portalId={hubspotEmbed.portalId}
            formId={hubspotEmbed.formId}
            region={hubspotEmbed.region}
          />
        }
      </FocusLock>
    </div>
  )
}

export default connect(
  state => ({
    hubspotTag: state.hubspotModal.tag,
  }),
  dispatch => ({
    closeHubspotModal: () => dispatch.hubspotModal.toggleModal(false),
  })
)(HubspotModal)
